import { persist } from 'zustand/middleware';
import {create} from 'zustand';
import { TreeNode } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { Gastos } from '@/shared/interfaces/erp/inventario';

export enum CuentasContablesKey {
  cuentasContables = 'cuentasContables',
}
export enum GastosKey {
  gastos = 'gastos',
}

export interface CuentasContablesStore {
  cuentasContables: TreeNode[];
  gastos: Gastos[];

  setSelectedCuentasContables: (cuentasContables: TreeNode[] , key: CuentasContablesKey ) => void;
  deleteSelectedCuentasContables: (id: string, key: CuentasContablesKey) => void;
  clearSelectedCuentasContables: (key: CuentasContablesKey) => void;
  addGastos:(items:Gastos,key:GastosKey) => void;
  deleteGastos:(id: string, key: GastosKey) => void;
}
const setAlert = useUiStore.getState().setAlert;

const idsAreEqual = (id1: string | number, id2: string | number) => {
  if (typeof id1 === 'number' && typeof id2 === 'number' && isFinite(id1) && isFinite(id2)) {
    return id1 === id2;
  }
  if (typeof id1 === 'string' && typeof id2 === 'string') {
    return id1 === id2;
  }
  return false;
}
export const useCuentasContablesStore = create<CuentasContablesStore>()(
  persist(
    (set, get) => ({
        cuentasContables: [],
        gastos: [],
        setSelectedCuentasContables: (cuentasContables, key) => {
          set({ [key]: cuentasContables });
        },
        deleteSelectedCuentasContables: (id, key) => {
          set(state => ({
            [key]: state[key].filter((cuenta: TreeNode) => cuenta.id !== id),
          }));
        },
        clearSelectedCuentasContables: key => {
          set({ [key]: [] });
        },
        addGastos:(item:Gastos, key:GastosKey) => {
          const itemExists = get()[key].some(
            i  => JSON.stringify(i) === JSON.stringify(item)
          );
          if (!itemExists) {
            set(state => ({
              [key]: [...state[key], item],
            }));
            setAlert(true, 'Item agregado correctamente', 'success');
          } else {
            setAlert(true, 'Ya se encuentra agregado este gasto', 'warning');
          }
        },
        deleteGastos:(id_gasto, key) => {
          set(state => ({
           ...state,
            [key]: state[key].filter(item => !idsAreEqual(item.id_gasto!, id_gasto)),
          }));
        },  
    }),

    {
      name: 'cuentasContables',
    }
)
);